import { Button, CircularProgress } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';

const MainSaveButton = ({ text = "Guardar", onClick, marginTop, loading, disabled, fullWidth = false, icon = <SaveIcon /> }) => {
  return (
    <Button
      variant="contained"
      endIcon={loading ? <CircularProgress size={20} color="inherit" /> : icon}
      disabled={loading || disabled}
      sx={{
        fontWeight: "bold",
        fontFamily: "poppins",
        paddingBlock: "4px",
        backgroundColor: "#ff6400",
        transform: "all",
        animationDuration: "1000",
        textTransform: "none",
        borderRadius: "8px",
        fontSize: "0.7rem",
        width: fullWidth ? "100%" : "fit-content",
        marginTop: marginTop,
        '&:hover': {
          backgroundColor: "#bb4a03",
        }
      }}
      onClick={onClick}
    >
    {text}
  </Button>
  )
}

export default MainSaveButton;
